/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CoreBaseService } from '../core-base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { CoreStrictHttpResponse } from '../core-strict-http-response';

import { appControllerHandleEvent } from '../fn/events/app-controller-handle-event';
import { AppControllerHandleEvent$Params } from '../fn/events/app-controller-handle-event';

@Injectable({ providedIn: 'root' })
export class CoreEventsService extends CoreBaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `appControllerHandleEvent()` */
  static readonly AppControllerHandleEventPath = '/o2-core/events';

  /**
   * Process SQS/EventBridge events.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerHandleEvent()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvent$Response(params?: AppControllerHandleEvent$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<void>> {
    const obs = appControllerHandleEvent(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Process SQS/EventBridge events.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerHandleEvent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvent(params?: AppControllerHandleEvent$Params, context?: HttpContext): Observable<void> {
    const resp = this.appControllerHandleEvent$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<void>): void => r.body)
    );
  }

}
